const _temp0 = require("bundle-text:./svgs/artworks/bodhi-tree.svg");
const _temp1 = require("bundle-text:./svgs/artworks/sculpture.svg");
const _temp2 = require("bundle-text:./svgs/artworks/snowman.svg");
const _temp3 = require("bundle-text:./svgs/artworks/the-high-perpetual-xmas-no-abstractions.svg");
const _temp4 = require("bundle-text:./svgs/artworks/the-world-turns.svg");
const _temp5 = require("bundle-text:./svgs/artworks/tow-row.svg");
const _temp6 = require("bundle-text:./svgs/artworks/we-are-shipwrecked-and-landlocked.svg");
module.exports = {
  "bodhi-tree": _temp0,
  "sculpture": _temp1,
  "snowman": _temp2,
  "the-high-perpetual-xmas-no-abstractions": _temp3,
  "the-world-turns": _temp4,
  "tow-row": _temp5,
  "we-are-shipwrecked-and-landlocked": _temp6
}